import { type FC } from "react";

import { ColoredLabel } from "widgets";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { getCssColor } from "@/app-utils/color.ts";
import type { SampleStatus } from "@/graphql.ts";

const ParentStatusCell: FC<IAgGridCellProps> = (props) => {
  const { data, colDef } = props;

  // get rid of the ".stringValue" trailer
  const field: string = colDef.field.substring(0, colDef.field.lastIndexOf("."));
  const status: SampleStatus = data?.[field]?.[0].parent?.status;

  return (
    <TableCell>
      <ColoredLabel color={status?.color ? getCssColor(status?.color) : undefined} label={status?.name} />
    </TableCell>
  );
};

export { ParentStatusCell };
export default ParentStatusCell;
